/**
 * Utility functions for formatting user identifiers.
 */

/**
 * Format a user ID for display. Returns the raw identifier (email or username).
 *
 * @param userId - User ID (could be email, username like "dae.user1", or Cognito user ID)
 * @returns The user ID as-is, or "Unknown User" if empty
 */
export function formatUserId(userId: string | undefined | null): string {
  if (!userId) {
    return "Unknown User"
  }
  return userId
}
